import React from 'react';
import {Routes as RouterRoutes, Route, Navigate} from 'react-router-dom';
import {AUTHENTICATED_ENTRY} from 'configs/AppConfig';
import {panelRoutes, protectedRoutes, publicRoutes, thirdPartyProtectedRoutes} from 'configs/RoutesConfig';
import ProtectedRoute from './ProtectedRoute';
import PublicRoute from './PublicRoute';
import ThirdPartyRoute from './ThirdPartyRoute';
import AppRoute from './AppRoute';
import PanelRoute from "./PanelRoute";

const Routes = () => {
    return (
        <RouterRoutes>
            <Route path="/" element={<ThirdPartyRoute/>}>
                {thirdPartyProtectedRoutes.map((route, index) => (
                    <Route
                        key={`${route.key}-${index}`}
                        path={route.path}
                        element={
                            <AppRoute
                                routeKey={route.key}
                                component={route.component}
                                {...route.meta}
                            />
                        }
                    />
                ))}
            </Route>

            {/* Protected Routes */}
            <Route path="/" element={<ProtectedRoute/>}>
                <Route
                    path="/"
                    element={<Navigate replace to={AUTHENTICATED_ENTRY}/>}
                />
                {protectedRoutes.map((route, index) => (
                    <Route
                        key={`${route.key}-${index}`}
                        path={route.path}
                        element={
                            <AppRoute
                                routeKey={route.key}
                                component={route.component}
                                {...route.meta}
                            />
                        }
                    />
                ))}
                <Route path="*" element={<Navigate to="/" replace/>}/>
            </Route>

            {/* Public Routes */}
            <Route path="/" element={<PublicRoute/>}>
                {publicRoutes.map((route) => (
                    <Route
                        key={route.path}
                        path={route.path}
                        element={
                            <AppRoute
                                routeKey={route.key}
                                component={route.component}
                                {...route.meta}
                            />
                        }
                    />
                ))}
            </Route>

            {/* Panel Routes */}
            <Route path="/" element={<PanelRoute/>}>
                <Route
                    path="/"
                    element={<Navigate replace to={`/panel/dashboard`}/>}
                />
                {panelRoutes.map((route, index) => (
                    <Route
                        key={`${route.key}-${index}`}
                        path={route.path}
                        element={
                            <AppRoute
                                routeKey={route.key}
                                component={route.component}
                                {...route.meta}
                            />
                        }
                    />
                ))}
                <Route path="*" element={<Navigate to="/" replace/>}/>
            </Route>
        </RouterRoutes>
    );
};

export default Routes;
